module.exports = __webpack_public_path__ + "img/download-homework.6c5da180.svg";